import { DisplayDataProps } from "../../../types";
import useDisplayDataStyles from "./styles";

const DisplayData = (props: DisplayDataProps) => {
    const { text, importedData, hideColon = false, isBold = true, verticalCenter = false } = props;
    const displayDataStyles = useDisplayDataStyles();

    const colon = hideColon ? "" : ":";
    return (
        <>
            {importedData && (
                <div className="d-flex">
                    <div className="flex-shrink-1" style={{ ...displayDataStyles.label, ...(isBold ? displayDataStyles.bold : {}), ...(verticalCenter ? {alignContent:"center"} : {}) }} >
                        {text ? text + colon : null}
                    </div>
                    <span className="flex-fill" style={displayDataStyles.data}>{importedData}</span>
                </div>
            )}
        </>
    );
};

export default DisplayData;
